import { store, getClient, bearerAuth } from '@src/core/store';

const useApiClient = () => {
  const state = store.getState();

  const {
    auth: { buyerToken },
  } = state;

  return {
    ...getClient(state),
    bearerAuth: buyerToken ? bearerAuth(buyerToken) : {},
  };
};

export default useApiClient;
